import React, { FC, ReactNode } from 'react';

import usePlankTableStore from '../../hooks/usePlankTableStore';
import { columnVoorraadDisplayName, isDefectColumn } from '../../utils/ddp';
import { getColumnWidthForType } from '../../utils/table';
import IndelenPanel from '../indelen/IndelenPanel';
import PlankNothingToShow from '../PlankNothingToShow/PlankNothingToShow';
import PlankViewSwitcher from '../PlankViewSwitcher/PlankViewSwitcher';

import plankStyles from '../../PlankView.module.css';
import tableStyles from './Table.module.css';

type TableHeaderProps = { children: ReactNode };
const TableHeaders: FC<TableHeaderProps> = ({ children }) => {
  const totalWidth = usePlankTableStore((state) => state.getTotalWidth());
  const columns = usePlankTableStore((state) => state.getColumns());
  const rows = usePlankTableStore((state) => state.getRows());

  const showIndelenPanel = usePlankTableStore((state) => state.showIndelenPanel);
  const setShowIndelenPanel = usePlankTableStore((state) => state.setShowIndelenPanel);
  return (
    <div
      className={tableStyles.ddpStyle}
      style={{ '--plank-view-width': `${totalWidth}px`, width: `${totalWidth}px` } as React.CSSProperties}
    >
      <div style={{ position: 'sticky', top: '0px', left: '0px', zIndex: 99 }}>
        <div className={tableStyles.tableHeadersRowStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <h1 className={plankStyles.plankH1}>Materieelbeheer</h1>
            <PlankViewSwitcher />
          </div>
        </div>
        <div className={tableStyles.tableColumnHeadersRowStyle}>
          <div
            className='column-first'
            style={{
              position: 'sticky',
              zIndex: 2,
              left: 0,
              backgroundColor: 'var(--tractie-color-background-elevated-sunken)',
              padding: '0 24px',
            }}
          >
            <IndelenPanel open={showIndelenPanel} setOpen={setShowIndelenPanel} />
          </div>
          <div className={tableStyles.tableDDPColumnsRowStyle}>
            {columns.map((col) => {
              const colWidth = getColumnWidthForType(columns.length, isDefectColumn(col));
              return (
                <div
                  key={`${col}`}
                  className={tableStyles.columnHeaderStyle}
                  style={{ minWidth: `${colWidth}px` } as React.CSSProperties}
                >
                  <h3 className={plankStyles.plankH3}>
                    {col === 'Voorraadbeheer' ? columnVoorraadDisplayName() : col}
                  </h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {children}
      {!rows.length && <PlankNothingToShow openIndelenPanel={() => setShowIndelenPanel(true)} />}
    </div>
  );
};
export default TableHeaders;
